/*eslint-disable*/
import { Spin } from 'antd';
import { Suspense } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import withAdminLayout from '../../layout/withAdminLayout';
import AccessControl from './access-control';
import Auth from './auth';
import Billing from './billing';
import Campaign from './campaign';
import Checkout from './checkout';
import Companies from './companies';
import Company from './company';
import Conversation from './conversation';
import Coupon from './coupon';
import CRM from './crmRoutes';
import Dashboard from './dashboard';
import Deployment from './deployment';
import Email from './email';
import Instruction from './instruction';
import Integration from './integration';
import Knowledge from './knowledge';
import Messenger from './messenger';
import Products from './products';
import Profile from './profile';
import Ticket from './ticket';

const Admin = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route path={path} component={Dashboard} />
        <Route path={`${path}/conversations`} component={Conversation} />
        <Route path={`${path}/ticket`} component={Ticket} />
        <Route path={`${path}/integration`} component={Integration} />
        <Route path={`${path}/instructions`} component={Instruction} />
        <Route path={`${path}/user`} component={Auth} />
        <Route path={`${path}/deployment`} component={Deployment} />
        <Route path={`${path}/settings`} component={AccessControl} />
        <Route path={`${path}/knowledge`} component={Knowledge} />
        <Route path={`${path}/products`} component={Products} />
        <Route path={`${path}/facebook/message`} component={Messenger} />
        <Route path={`${path}/billing`} component={Billing} />
        <Route path={`${path}/checkout`} component={Checkout} />
        <Route path={`${path}/coupons`} component={Coupon} />
        <Route path={`${path}/profile`} component={Profile} />
        <Route path={`${path}/company`} component={Company} />
        <Route path={`${path}/companies`} component={Companies} />
        <Route path={`${path}/campaign`} component={Campaign} />
        <Route path={`${path}/crm`} component={CRM} />
        <Route path={`${path}/email`} component={Email} />
      </Suspense>
    </Switch>
  );
};

export default withAdminLayout(Admin);
